import { useEffect } from 'react';
import {useHistory} from 'react-router-dom';

const OnRouteChange = () => {
    const history = useHistory();

    useEffect(() => {
        history.listen((location, action) => {
            // location is an object like window.location
            // console.log(location);
        });
    }, []);

    return null;
}

export default OnRouteChange;